import React, { useEffect, useState } from "react";
import "./UserPortfolio.css";
import { Grid, Card, CardContent, Tooltip } from "@material-ui/core";
import CardLogo from "../../../Assets/cards phnx logo.svg";
import { connect, useDispatch } from "react-redux";
import Web3 from "web3";
import { truncateValue } from "../../../utils";
import { useWeb3React } from "@web3-react/core";
import {
  getBalance,
  onGetInterestRate,
  onGetTotalStakedToken,
  GetDashboardDataAction,
} from "../../../store/actions/dashboardActions";

const UserPortfolio = (props) => {
  const dispatch = useDispatch();
  const [stakes, setStakes] = useState([]);
  const [stakesHistory, setStakesHistory] = useState([]);
  const [data, setData] = useState(null);
  const [availablePhnx, setAvailablePhnx] = useState(0);
  const [stakedBalance, setStakedBalance] = useState(0);
  const [loading, setLoading] = useState(false);

  const context = useWeb3React();
  const { chainId, account, activate, deactivate, active } = context;

  useEffect(() => {
    if (props.network != 1) {
      setData(null);
      return;
    }
    // getDashboardData();
    if (props.address) {
      dispatch(GetDashboardDataAction(props.address));
    }
  }, [
    props.address,
    props.balance,
    props.availableAmount,
    props.stakeLoading,
    props.network,
    props.onStakeConfirmationNumber, // both stake/unstake nums are updating sidewise
    props.onUnstakeConfirmationNumber,
    account,
    chainId,
  ]);

  useEffect(() => {
    if (props.dashboardData) {
      setData(props.dashboardData);
    }
  }, [props.dashboardData, props.balance, props.address]);

  useEffect(() => {
    const ethereum = window.ethereum;
    if (ethereum) {
      props.onGetInterestRate();
    }
    if (props.address) {
      props.getBalance(props.address);
    }
  }, [props.address, props.network]);

  useEffect(() => {
    if (props.network != 1) {
      setStakes([]);
      setStakesHistory([]);
      return;
    }
    if (data && data.user) {
      // console.log("data at user portfolio", data);
      setStakes(data.user?.stake?.filter((_stake) => _stake.altQuantity > 0));
      setStakesHistory(data.user.history);
    } else {
      setStakes([]);
      setStakesHistory([]);
    }
  }, [data, props.phnxAmount, props.address, props.network]);

  useEffect(() => {
    if (props.network != 1) {
      setStakedBalance(0);
      return;
    }
    if (data && data.user) {
      if (props.dashboardData?.user?.stake?.length < 1) {
        setStakedBalance(0);
        return;
      }
      let amount = truncateValue(
        props.dashboardData?.user?.stake
          ?.map((_stake) => parseFloat(Web3.utils.fromWei(_stake.altQuantity)))
          .reduce((a, b) => a + b, 0)
      );
      // console.log("amounttt", amount);
      amount ? setStakedBalance(amount) : setStakedBalance(0);

      amount = 0;
    }
  }, [
    props.phnxAmount,
    props.address,
    data,
    availablePhnx,
    props.dashboardData,
    props.totalStakedTokens,
    props.contractBalance,
    props.network,
  ]);

  useEffect(() => {
    let balance = truncateValue(props.balance);
    if (balance) {
      setAvailablePhnx(balance);
    } else {
      setAvailablePhnx(0);
    }
    props.onGetTotalStakedToken();
  }, [props.balance, props.address, data, props.network]);

  return (
    <Grid
      style={{ marginTop: "20px" }}
      xs={12}
      justify="space-around"
      container
      item
    >
      <Grid xs={12} sm={4} item>
        <Card className="firstCard">
          <CardContent
            style={{ display: "flex", padding: "16px", lineHeight: 1 }}
          >
            <div style={{ display: "inline-block", fontWeight: "bold" }}>
              <Tooltip title="This is the total amount of $PHNX available in your wallet, this is usually connected to your Metamask or Numio wallet.">
                <p className="cardHeading">Available PHNX</p>
              </Tooltip>

              <p className="cardData">{availablePhnx}</p>
            </div>
            <div
              style={{
                display: "inline-block",
                textAlign: "right",
                marginLeft: "auto",
                marginTop: "auto",
                marginBottom: "auto",
              }}
            >
              <img className="cardImage" src={CardLogo} />
            </div>
          </CardContent>
        </Card>
      </Grid>
      <Grid xs={12} sm={4} item>
        <Card className="secondCard">
          <CardContent
            style={{ display: "flex", padding: "16px", lineHeight: 1 }}
          >
            <div style={{ display: "inline-block", fontWeight: "bold" }}>
              <Tooltip title="This is the total amount of $PHNX you have successfully staked on the dApp.">
                <p className="cardHeading"> Staked PHNX</p>
              </Tooltip>

              <p className="cardData">{stakedBalance}</p>
            </div>
            <div
              style={{
                display: "inline-block",
                textAlign: "right",
                marginLeft: "auto",
                marginTop: "auto",
                marginBottom: "auto",
              }}
            >
              <img className="cardImage" src={CardLogo} />
            </div>
          </CardContent>
        </Card>
      </Grid>
      <Grid xs={12} sm={4} item>
        <Card className="thirdCard">
          <CardContent
            style={{ display: "flex", padding: "16px", lineHeight: 1 }}
          >
            <div style={{ display: "inline-block", fontWeight: "bold" }}>
              <Tooltip title="This shows the instant reward (Accumulated Percentage Yield, APY) accrued on the $PHNX you have staked.">
                <p className="cardHeading">Spot Reward</p>
              </Tooltip>
              <p className="cardData">
                {`${props.interest ? props.interest : 0}%`}
              </p>
            </div>
            <div
              style={{
                display: "inline-block",
                textAlign: "right",
                marginLeft: "auto",
                marginTop: "auto",
                marginBottom: "auto",
              }}
            >
              <img className="cardImage" src={CardLogo} />
            </div>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    address: state.layoutReducer.address,
    balance: state.dashboardReducer.balance,
    interest: state.dashboardReducer.interest,
    stakedPhnx: state.dashboardReducer.stakedPhnx,
    // portalLoading: state.dashboardReducer.loading,
    activePortal: state.dashboardReducer.activePortal,
    portalInterestList: state.dashboardReducer.interestList,
    // totalStakedTokens: state.dashboardReducer.totalStaked,
    contractBalance: state.dashboardReducer.contractBalance,
    stakeLoading: state.layoutReducer.stakeLoading,
    unstakeAmount: state.unstakeReducer.unstakeAmount,
    network: state.layoutReducer.network,
    availableAmount: state.unstakeReducer.availableAmount,

    phnxAmount: state.stakeReducer.phnxAmount,
    days: state.stakeReducer.days,
    onStakeConfirmationNumber: state.stakeReducer.onStakeConfirmationNumber,
    onUnstakeConfirmationNumber:
      state.unstakeReducer.onUnstakeConfirmationNumber,

    dashboardData: state.dashboardReducer.dashboardData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getBalance: (address) => dispatch(getBalance(address)),
    onGetTotalStakedToken: () => dispatch(onGetTotalStakedToken()),
    // checkRemainingTransactions: (address) => dispatch(checkRemainingTransactions(address)),
    onGetInterestRate: () => dispatch(onGetInterestRate()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPortfolio);
